import { createCtx } from '@panwds/react-ui';

const [useNavigationContext, InnerNavigationProvider] = createCtx();

export { InnerNavigationProvider, useNavigationContext };
//# sourceMappingURL=NavigationContext.esm.js.map
